<template>
  <div id="TemplateSelect" class="extended-forms">
    <div class="row">
      <div class="col-md-4">
        <v-select
          class="select-primary"
          size="large"
          placeholder="템플릿 사용 안함"
          :clearable="false"
          :options="templates"
          label="title"
          :reduce="(title) => title.id"
          v-model="template"
        >
        </v-select>
      </div>
      <base-button @click="applyTemplate('add')" type="default">추가</base-button>
      <base-button @click="applyTemplate('overwrite')" type="default">덮어쓰기</base-button>
      <base-button v-if="showBottomButton" @click="applyTemplate('bottom')" type="default">마지막추가</base-button>
      <base-button @click="copyClipboard()" type="default">복사</base-button>
    </div>
  </div>
</template>
<script>
export const TemplateLocation = Object.freeze({
  ADD: "add",
  OVERWRITE: "overwrite",
  BOTTOM: "bottom",
});

import * as _ from "lodash";
export default {
  name: "TemplateSelect",
  async created() {
    await this.getTemplateByType();
  },
  data() {
    return {
      templates: [],
      template: null,
    };
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    showBottomButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    copyClipboard() {
      const dom = document.createElement("textarea");
      document.body.appendChild(dom);
      dom.value = _.find(this.templates, { id: this.template }).contents;
      dom.select();
      document.execCommand("copy");
      document.body.removeChild(dom);
      Toast.success("클립보드에 복사되었습니다");
    },
    applyTemplate(location) {
      const selectedTemplate = _.find(this.templates, { id: this.template });
      if (selectedTemplate.id) {
        this.$emit("templateApply", {
          location,
          contents: selectedTemplate.contents,
        });
      }
    },
    async getTemplateByType() {
      const params = { type: this.type };
      return this.$axios.get(`/templates`, { params }).then((res) => {
        this.templates = [{ id: null, title: "템플릿 사용 안함", contents: null }, ...res.data.data.data];
      });
    },
  },
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
}
.vs__dropdown-toggle {
  border: 1px solid rgb(0 0 0);
  padding: 6px 0 6px 0;
}
.vs__selected {
  color: #ff35e6;
}
</style>
